import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const cartGuard: CanActivateFn = (route, state) => {
    const platformId = inject(PLATFORM_ID);
    const router = inject(Router);

    if (isPlatformBrowser(platformId)) {
        const savedCart = localStorage.getItem('cart_response');
        if (savedCart) {
            try {
                const parsed = JSON.parse(savedCart);
                if (parsed && parsed.data && parsed.data.cartItems && parsed.data.cartItems.length > 0) {
                    return true;
                }
            } catch (e) {
                console.error('Error parsing cart data in guard', e);
            }
        } else {
            return router.parseUrl('/')
        }
    }

    // Redirect to home if cart is empty or not in browser
    // return router.parseUrl('/');
    return true;
};
